import type { DataLayerEvent } from '@rover/types/src/DataLayerEvent';
import inject from '@rover/utilities/injector';

// Mirrors the backend InitiationSource.SHORTLIST_CONTACT_PAGE enum.
export const SHORTLIST_CONTACT_PAGE = 'shortlist_contactpage';

const INITIATION_SOURCE_BY_PAGE_CATEGORY: Record<string, string> = {
  'multi-contact-sitter': SHORTLIST_CONTACT_PAGE,
};

const CONTACT_FLOW_EVENT_PREFIX = 'owner-conversion-contact-sitter-flow';

// Tags contact-flow events with the flow they were fired from, derived from the page
// category so the shared nested components emitting them need no plumbing. Pages absent
// from the map above emit no value, so absence = single-sitter contact page.
const withInitiationSource = (event: DataLayerEvent): DataLayerEvent => {
  if (!event.event?.startsWith(CONTACT_FLOW_EVENT_PREFIX)) return event;

  const initiationSource = INITIATION_SOURCE_BY_PAGE_CATEGORY[inject('Rover.pageCategory', '')];

  // A value set by the caller wins.
  return initiationSource ? { initiationSource, ...event } : event;
};

export default withInitiationSource;
